const TOAST_TYPE = {
  SUCCESS: "success",
  ERROR: "error",
  WARNING: "warning"
};
export default TOAST_TYPE;
